import { Observable } from 'rxjs';

export interface AggregateBadge {
  title: string;
  value$: Observable<number>;
  color: string;
}
